import api from './api';

export const fetchSettingsSummary = (params = {}) =>
  api.get('/organizer-charges/settings-summary', { params }).then((r) => r.data);

export const fetchChargesForSetting = (settingId, params = {}) =>
  api.get('/organizer-charges/charges', {
    params: { ...params, charge_settings_id: settingId },
  }).then((r) => r.data);

export const fetchPaymentsForSetting = (settingId, params = {}) =>
  api.get(`/organizer-charges/charges-settings/${settingId}/payments`, { params }).then((r) => r.data);

export const fetchDebtorsForSetting = (settingId) =>
  api.get(`/organizer-charges/charges-settings/${settingId}/debtors`).then((r) => r.data);

// Lista consolidada cross-setting (regra: emissão + 2 dias)
export const fetchAllDebtors = () =>
  api.get('/organizer-charges/debtors').then((r) => r.data);

export const markInvoicePaid = (invoiceId) =>
  api.put(`/organizer-charges/invoices/${invoiceId}/download`).then((r) => r.data);

export const fetchFreePlayersForSetting = (settingId) =>
  api.get('/organizer-charges/free-players', {
    params: { charge_settings_id: settingId },
  }).then((r) => r.data);

export const fetchManageFreePlayers = (settingId) =>
  api.get('/organizer-charges/free-players/manage', {
    params: { charge_settings_id: settingId },
  }).then((r) => r.data);

export const saveFreePlayersBatch = (settingId, playerIds) =>
  api.post('/organizer-charges/free-players/batch', {
    charge_settings_id: settingId,
    player_ids: playerIds,
  }).then((r) => r.data);
